import styled, { css } from "styled-components";

import { Text } from "@ui/Atoms";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.spacing_24};
  gap: ${({ theme }) => theme.spacing.spacing_24};
  background-color: ${({ theme }) => theme.palette.blue50};
  border-radius: 12px;

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    gap: ${({ theme }) => theme.spacing.spacing_32};
    padding: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

export const Title = styled(Text).attrs({
  $style: {
    default: "bold_40",
    smallTablet: "bold_56",
    smallDesktop: "bold_72",
  },
  $breakWord: true,
})``;

export const StepDescription = styled(Text).attrs({
  $style: {
    default: "regular_16",
    smallDesktop: "regular_18",
  },
})``;

export const BookingSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: row;
  }
`;

export const Step = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  min-height: 72px;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: column;
    min-height: 0;
  }
`;

export const StepIcon = styled.div<{ $withoutLine?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: row;
  }

  &::after {
    display: block;
    content: "";
    background-color: ${({ theme }) => theme.palette.grey800};
    position: relative;

    min-height: 60px;
    height: 100%;
    left: 0;
    top: 5px;
    width: 2px;

    ${({ theme }) => theme.breakpointsV2.smallTablet} {
      min-height: 0;
      width: 100%;
      left: 16px;
      top: 0;
      height: 2px;
    }
  }

  ${({ $withoutLine }) =>
    $withoutLine &&
    css`
      &::after {
        display: none;
      }
    `}

  & > * {
    flex-shrink: 0;
  }
`;

export const CallToActionWrapper = styled.div`
  width: fit-content;
  padding-top: ${({ theme }) => theme.spacing.spacing_16};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding: 0;
  }
`;
